// extracted by mini-css-extract-plugin
export default {"header":"HeaderMain_header__4wmb4","titleContainer":"HeaderMain_titleContainer__IBkKp","title":"HeaderMain_title__jTakR"};